/*
 * Actions types
 */
export enum AuthTypes {
  PRE_SIGN_IN_REQUEST = '@auth/PRE_SIGN_IN_REQUEST',
  PRE_SIGN_IN_SUCCESS = '@auth/PRE_SIGN_IN_SUCCESS',
  PRE_SIGN_FAILURE = '@auth/PRE_SIGN_FAILURE',
  SELECT_EMAIL = '@auth/SELECT_EMAIL',
  REQUEST_PWD_SIGN_IN_REQUEST = '@auth/REQUEST_PWD_SIGN_IN_REQUEST',
  REQUEST_PWD_SIGN_IN_SUCCESS = '@auth/REQUEST_PWD_SIGN_IN_SUCCESS',
  REQUEST_PWD_SIGN_FAILURE = '@auth/REQUEST_PWD_SIGN_FAILURE',
  SIGN_IN_REQUEST = '@auth/SIGN_IN_REQUEST',
  SIGN_IN_SUCCESS = '@auth/SIGN_IN_SUCCESS',
  SIGN_FAILURE = '@auth/SIGN_FAILURE',
  SIGNOUT_REQUEST = '@auth/SIGNOUT_REQUEST',
  SIGNOUT_SUCCESS = '@auth/SIGNOUT_SUCCESS',
  SIGNOUT_FAILURE = '@auth/SIGNOUT_FAILURE',
  SIGNED_REQUEST = '@auth/SIGNED_REQUEST',
  SIGNED_SUCCESS = '@auth/SIGNED_SUCCESS',
  SIGNED_FAILURE = '@auth/SIGNED_FAILURE',
  COMPANY_REQUEST = '@auth/COMPANY_REQUEST',
  COMPANY_SUCCESS = '@auth/COMPANY_SUCCESS',
  COMPANY_FAILURE = '@auth/COMPANY_FAILURE',
}

export interface RequestSignIn {
  identificationKey: number;
  ownershipType: string;
  countryCompanyId: number;
  emailIndex?: number;
  pwd?: string;
  recaptcha: string;
}

/*
 * State Type
 */
export interface AuthState {
  readonly id_token: string;
  readonly token: string;
  readonly company: any;
  readonly signed: boolean;
  readonly loading: boolean;
  readonly error: boolean;
}
